import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/procesos/procesos';
import ProcesosList from './ProcesosList';


const ms2p = (state) => {
  return {
    ...state.procesos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ProcesosList);
